import React from "react";
import { useNavigate } from "react-router-dom";
import Datatable from "./common/datatable";
import ActionMenu from "./common/menu";
import FallbackImage from "./common/fallbackImage";

const UserData = ({ data, onEdit, onView, onDelete }) => {
  const navigate = useNavigate();

  const handleView = (user) => {
    const id = user._id || user.id;
    navigate(`/user/view/${id}`);
  };

  const columns = [
    {
      key: "profilePicture",
      label: "Profile Picture",
      className: "company-logo",
      render: (value, row) => {
        const src = value || row?.profilePicturePath;
        if (!src) return null;
        return (
          <FallbackImage
            src={src}
            alt="Profile"
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        );
      },
    },
    { key: "name", label: "User Name" },
    {
      key: "email",
      label: "Email",
      render: (value) => <span className="tab-tds">{value}</span>,
    },
    {
      key: "phone",
      label: "Phone",
      render: (value) => <span className="tab-tds">{value}</span>,
    },
    {
      key: "country",
      label: "Country",
      render: (value, row) => row.country || row.location || "-",
    },
    {
      key: "designation",
      label: "Designation",
      render: (value) => <span className="tab-tds">{value}</span>,
    },

    {
      key: "actions",
      label: "Actions",
      render: (value, row) => (
        <ActionMenu 
          row={row}
          onView={handleView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];

  return (
    <>
      <Datatable data={data} columns={columns} />
    </>
  );
};

export default UserData;
